import type { FormTypeKey } from "./types";

export const FORM_DESCRIPTIONS: Record<string, string> = {
  PD7A: "Statement of Account for Current Source Deductions",
  T4: "Statement of Remuneration Paid",
  T4A: "Statement of Pension, Retirement, Annuity, and Other Income",
  "941": "Employer's Quarterly Federal Tax Return",
  W2: "Wage and Tax Statement",
  EPS: "Employer Payment Summary",
  BAS: "Business Activity Statement",
};

export const describeForm = (type: FormTypeKey): string =>
  FORM_DESCRIPTIONS[type] || "";